<script>
	import Routes from './utils/Routes.svelte';
	
	jQuery(document).ready(function(){
			jQuery('.my-slick').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				variableWidth: true,
				arrows: false,
				fade: false,
				responsive: [
					{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: true,
						variableWidth: false,
						dots: true
					}
					},
					{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						variableWidth: false,
						slidesToScroll: 2
					}
					},
					{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						variableWidth: false,
						slidesToScroll: 1
					}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			});

			jQuery('.mangomist-slick-home-carousel').slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				variableWidth: false,
				arrows: true,
				fade: false,
				responsive: [
					{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: true,
						variableWidth: false,
						dots: true
					}
					},
					{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						autoplay: true,
						variableWidth: false,
						slidesToScroll: 2
					}
					},
					{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						autoplay: true,
						variableWidth: false,
						slidesToScroll: 1
					}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			});
			
		});
</script>

<Routes />